<template>
  <div
    class="additional-load"
    :class="{
      'additional-load-red': record.additionalLoad.value > 10 && record.postCode === 'driver',
      'additional-load-green': record.additionalLoad.value < 10 && record.postCode === 'driver',
      'additional-load-grey': record.additionalLoad.value.length === 0 && record.postCode === 'driver',
    }"
  >
    <div v-if="record.postCode === 'driver'" class="additional-load-driver-desc">Время без дела:</div>
    <div v-if="record.postCode === 'driver'" class="additional-load-driver-value">
      {{ record.additionalLoad.value }}%
    </div>

    <div v-if="record.postCode === 'suhi'" class="additional-load-suhi-desc">Лосось, кг</div>
    <div v-if="record.postCode === 'suhi'" class="additional-load-suhi-value">
      <c-input
        v-model="suhiAdditionalLoadValue"
        class="additional-load-suhi-value-input"
        placeholder="0"
        type="price-number"
      />
    </div>
  </div>
</template>
<script>
import Input from "@/components/controls2/Input";

export default {
  name: "additional-load-cell",
  components: {
    "c-input": Input,
  },
  props: ["record"],
  watch : {
    "suhiAdditionalLoadValue" : function (v) {
      v = parseFloat(v);
      if (!isNaN(v)) {
        this.$emit("salmon", v);
      }
    }
  },
  data() {
    return {
      suhiAdditionalLoadValue: "",
    };
  },
  mounted() {
    setTimeout(() => {
      if (this.record.postCode === "suhi") this.suhiAdditionalLoadValue = this.record.additionalLoad.value;
      if (!this.suhiAdditionalLoadValue) this.suhiAdditionalLoadValue="";
    }, 300);
  },
};
</script>
<style lang="scss" scoped>
.additional-load {
  line-height: 13px;
  font-size: 13px;
  height: 100%;
  -webkit-transition: font 0.3s ease;
  transition: font 0.3s ease;
  display: flex;
  align-items: center;

  &-red {
    background-color: rgb(255, 211, 232);
  }

  &-green {
    background-color: rgb(208, 244, 227);
  }

  &-grey {
    background: #f5f7fa;
  }

  &-driver-desc {
    color: #8e9cbb;
    padding: 10px 0 10px 10px;
  }

  &-driver-value {
    padding: 10px 10px 10px 5px !important;
  }

  &-suhi-desc {
    white-space: nowrap !important;
    height: 100%;
    color: #8e9cbb;
    padding: 10px !important;
  }

  &-suhi-value {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
    width: 100%;
    padding: 10px !important;
    border-left: 1px solid #dfe4ef;

    &:active,
    &:hover {
      outline-style: solid;
      outline-width: 1px !important;
      outline-color: #0066ff !important;
      box-shadow: 0 0 10px rgba(0, 102, 255, 0.4);
    }

    &-input {
      display: flex;
      align-items: center;
      max-width: 60px;
      width: 100%;
      height: 100%;

      &::v-deep .c-input-border {
        display: none;
      }

      &::v-deep .c-input-input {
        font-size: 13px;
        text-align: right;
        min-height: 15px;
        padding: 0 !important;
      }
    }
  }
}
</style>
